import {
  commonData,
  identityData,
  showroomData,
  ratingsData,
  servicesData,
} from "@/services/miniweb/data/formatDataMiniweb";
import { TEMPLATE_MINIWEB_LIST } from "@/services/miniweb/resolver";
// import LoadSections from '@/mixins/load-sections'

export function miniwebFormatedData(loadedParam) {
  // console.log('loaded param in miniwebFormatedData from elegant:')
  // console.log(loadedParam)
  // console.log(identityData)
  return {
    template: {
      ...commonData(
        {
          id: TEMPLATE_MINIWEB_LIST[1].id,
          name: TEMPLATE_MINIWEB_LIST[1].name,
        },
        loadedParam,
      ),
    },
    miniwebData: {
      identity: identityData(loadedParam),
      showroom: showroomData(loadedParam),
      services: servicesData(loadedParam),
      ratings: ratingsData(loadedParam),
    },
    /*
        miniwebToggle: {
            identity: identityToggle(loadedParam),
            showroom: showroomToggle(loadedParam),
            ratings: ratingsToggle(loadedParam),
        },
        */
    /*
            mixins: LoadSections([
            'sections/404',
//             'sections/contact-us',
//             'sections/info',
          ]),
        view: '@/views/anonymous/miniweb/elegant/Index.vue',
        */
  };
}

// export const VIEW = () => import('@/views/anonymous/miniweb/elegant/Index.vue')
export default miniwebFormatedData;
